<template>
  <nav
    v-if="!$route.meta.hideHeader && user"
    id="main-nav"
    class="navbar navbar-default navbar-inverse navbar-theme navbar-theme-abs navbar-black-transparent">
    <div class="container">
      <div class="navbar-inner nav">
        <div class="navbar-header">
          <!-- COMPANY LOGO -->
          <template v-if="$route.meta.hideContext">
            <router-link
              class="navbar-brand-icon"
              to="/">
              <i class="fa fa-home"></i> Home
            </router-link>
          </template>
          <template v-if="company && !$route.meta.hideContext">
            <router-link
              v-if="company.logo"
              class="navbar-brand"
              to="/">
              <img
                :src="company.logo"
                :alt="company.name"
                title="Ir para Home">
            </router-link>
            <router-link
              v-if="!company.logo"
              class="navbar-brand-icon"
              to="/">
              <i class="fa fa-home"></i> {{ company.name }}
            </router-link>
          </template>
          <!-- // COMPANY LOGO -->
          <button
            @click="handleToggleNav"
            class="navbar-toggle collapsed"
            type="button"
            area-expanded="false">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
        </div>

        <!-- MAIN MENU -->
        <div
          v-show="toggleNav"
          :class="{ 'show': toggleNav }"
          class="collapse navbar-collapse" id="navbar-main">
          <ul
            v-if="isLoggedIn"
            class="nav navbar-nav navbar-right">
            <template v-if="user.isAgent || user.isAdmin">
              <!-- CHANGE CONTEXT -->
              <li
                v-if="companies.length && !$route.meta.hideContext"
                class="navbar-nav-item-user dropdown">
                <change-context :companies="companies">
                  <template v-slot:trigger="{ handleDialog }">
                    <a
                      href="#"
                      @click.prevent="handleDialog">
                      <i class="fa fa-sign-in navbar-nav-item-user-icon"></i> Empresa
                    </a>
                  </template>
                </change-context>
              </li>
              <!-- // CHANGE CONTEXT -->
              <li
                v-if="user.isAdmin"
                class="navbar-nav-item-user dropdown">
                <a
                  :class="{ 'active' : $route.meta.hideContext }"
                  href="/agent/travels/" target="_blank">
                  <i class="fa fa-cogs navbar-nav-item-user-icon"></i>Painel de Operações
                </a>
              </li>
            </template>
            <li class="navbar-nav-item-user dropdown">
              <router-link to="/travel">
                <i class="fa fa-shopping-cart navbar-nav-item-user-icon"></i>Viagem
              </router-link>
            </li>
            <li class="navbar-nav-item-user dropdown">
              <a
                class="dropdown-toggle"
                data-toggle="dropdown"
                role="button"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="fa fa-user-circle-o navbar-nav-item-user-icon"></i>Preferências
              </a>
              <!-- DROPDOWN MENU -->
              <ul class="dropdown-menu">
                <li>
                  <router-link to="/myaccount">
                    Minha Conta
                  </router-link>
                </li>
                <li>
                  <router-link :to="{name:'orders'}" exact>
                    Meus Pedidos
                  </router-link>
                </li>
                <li v-if="user.isAdmin">
                  <router-link :to="{name:'orders', query:{all_orders: true}}" exact>
                    Todos os Pedidos
                  </router-link>
                </li>
                <li>
                  <router-link to="/company">
                    Empresa
                  </router-link>
                </li>
                <li>
                  <router-link :to="{name:'cards'}">
                    Cartões
                  </router-link>
                </li>
                <li v-if="user.isAgent || user.isAdmin">
                  <router-link to="/travelers">
                    Titulares
                  </router-link>
                </li>
                <li>
                  <router-link :to="{name:'travelersdependent', query:{all_dependents: false}}" exact>
                    Meus Dependentes
                  </router-link>
                </li>
                <li v-if="user.isAgent || user.isAdmin">
                  <router-link :to="{name:'travelersdependent', query:{all_dependents: true}}" exact>
                    Todos os Dependentes
                  </router-link>
                </li>
                <!-- <li>
                  <router-link :to="{name:'reports'}">
                    <a>Relatórios</a>
                  </router-link>
                </li> -->
                <li>
                  <a
                    @click.prevent="handleUserLogout"
                    href="#">
                    <i class="fa fa-sign-in" aria-hidden="true"></i>
                    Sair
                  </a>
                </li>
              </ul>
              <!-- // DROPDOWN MENU -->
            </li>
          </ul>
          <!-- // MAIN MENU -->
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import ChangeContext from '@/components/template/ChangeContext'
import { mapState, mapActions } from 'vuex';

export default {
  components: {
    ChangeContext
  },
  data () {
    return {
      toggleNav: (window.innerWidth < 768) ? false : ((window.innerWidth > 1024) ? true : false),
    }
  },
  computed: {
    ...mapState('auth', [
      'isLoggedIn',
      'user',
      'company'
    ]),

    companies () {
      return this.user.companies.filter(company => company.id !== this.company.id)
    }
  },
  methods: {
    ...mapActions('auth', [
      'getUserLogout',
    ]),
    handleUserLogout () {
      this.getUserLogout()
        .then(() => {
          this.$router.push({ name: 'login' })
        })
    },
    handleToggleNav () {
      this.toggleNav = !this.toggleNav
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/scss/components/template/header';
</style>
